var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIconSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.214,
    height: 15,
    viewBox: "-0.25 -0.25 21.214 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 15548"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.273 10.1 4.047 4.047a2.915 2.915 0 0 0 4.122 0l12.5-12.5A.972.972 0 0 0 19.568.273l-12.5 12.5a.972.972 0 0 1-1.374 0L1.647 8.725A.972.972 0 0 0 .273 10.1Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.273 10.1 4.047 4.047a2.915 2.915 0 0 0 4.122 0l12.5-12.5A.972.972 0 0 0 19.568.273l-12.5 12.5a.972.972 0 0 1-1.374 0L1.647 8.725A.972.972 0 0 0 .273 10.1h0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    stroke: "#fff",
    fill: "transparent"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIconSvg);
export default __webpack_public_path__ + "static/media/rightIconSVG.79e93c93d5054643b235cb618f076b5a.svg";
export { ForwardRef as ReactComponent };